import { MSP_ROUTES_FALLBACK as MSP_ROUTES } from '@/modules/msp/routes/constants';
import { useContext } from 'react';

import { IntegrationSystem } from '@/shared/types';

import AuthContext from '@/contexts/Auth/AuthContext';

import { OTHER_ROUTES, ROUTES } from '../router/config';

import { Breakpoints, useMediaQuery } from '@/hooks/useMediaQuery';

export const useNavigation = (): string[] => {
  const { isLoggedIn, systems } = useContext(AuthContext);
  const isMspSystemAvailable = systems?.includes(IntegrationSystem.MSP) ?? false;
  const isMobileSize = useMediaQuery(Breakpoints.SM);

  return [
    ROUTES.HOME,
    ROUTES.USER.REQUESTS.ACTIVE_REQUESTS,
    OTHER_ROUTES.erz.WEAPON_REGISTERED,
    MSP_ROUTES.SOCIAL_PROTECT,
    isLoggedIn && isMspSystemAvailable && MSP_ROUTES.NEWS,
    ROUTES.EXTERNAL_SERVICES,
    !isMobileSize && ROUTES.MAP,
  ].filter(Boolean) as string[];
};
